import { render } from "./ApprovalsPending.vue?vue&type=template&id=5c32125a&scoped=true"
import script from "./ApprovalsPending.vue?vue&type=script&lang=js"
export * from "./ApprovalsPending.vue?vue&type=script&lang=js"

import "./ApprovalsPending.vue?vue&type=style&index=0&id=5c32125a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c32125a"]])

export default __exports__